import { Injectable } from "@angular/core";
import { ProfileService } from "service/profile/profile.service";
import { Observable, switchMap } from "rxjs";
import { map, pluck } from "rxjs/operators";
import { LanguageService } from "service/translate/translate.service";
import { RestApiService } from "core/rest-api/lib/rest-api.service";
import { SharedService } from "service/shared/shared.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: "root",
})
export class RankService {
  constructor(
    private _profileService: ProfileService,
    private _languageService: LanguageService,
    private rest: RestApiService,
    private _sharedService: SharedService,
    private _translate: TranslateService
  ) {}

  getRank(): Observable<any> {
    return this._profileService.getIdUser().pipe(
      switchMap((id: number) => {
        return this._profileService
          .getRank(id)
          .pipe(
            map((results) =>
              results && results.length > 0 ? results[0] : null
            )
          );
      })
    );
  }

  getListRank(): Observable<any> {
    return this._profileService.getListRank();
  }

  getLanguage(): Observable<any> {
    return this._languageService.getLanguageChanged();
  }

  getRewards(urlParameters: any = {}): Observable<any> {
    return this.rest
      .post<any>("dinos-point/get-rewards", urlParameters)
      .pipe(pluck("info"));
  }

  exchange(params: any = {}): Observable<any> {
    return this.rest.post<any>("dinos-point/add-dinos-point-affiliate", params);
  }

  toastrSuccess(message: string, title: string) {
    this._sharedService.toastrSuccess(message, title, "profile-toast");
  }

  toastrError(message: string, title: string) {
    this._sharedService.toastrError(message, title, "profile-toast");
  }

  getTranslate(path: string): string {
    return this._translate.instant(path);
  }

  getMission(params: any = {}): Observable<any> {
    return this.rest
      .post<any>("dinos-point/get-mission", params)
      .pipe(pluck("info"));
  }

  getUserActivity(params: any = {}): Observable<any> {
    return this.rest
      .post("manager-dinos-point/user-activity?lang=en", params)
      .pipe(
        map((data) => {
          return {
            data: data.info.row,
            pagination: data.info.page_split,
          };
        })
      );
  }

  getProfile(): Observable<any> {
    return this._profileService.getProfile();
  }

  getCountries(): Observable<any> {
    return this._profileService.getCountries();
  }

  getProvinces(): Observable<any> {
    return this._profileService.getProvinces();
  }
}
